import { isBefore, parseISO, startOfToday, subDays } from 'date-fns';

import type { Statistics } from './types.js';

import {
  getItemFromLocalStorage,
  isLocalStorageSupported,
  removeItemFromLocalStorage,
} from '../../../../../../../public-src/core/js/local-storage.js';

export const countVotes = (
  answers: Record<number, string> | undefined,
): number => {
  if (!answers) return 0;

  return Object.values(answers)
    .map(Number)
    .reduce((sum, value) => sum + value, 0);
};

export const calcVotePercentages = (
  stats: Statistics,
  totalVotes: number,
  index: number,
): string => {
  const answers = stats?.answers || {};

  if (!answers || !totalVotes) return '0';

  const votesForAnswer = parseInt(answers[index], 10) || 0;

  const percentage = (votesForAnswer / totalVotes) * 100;

  return percentage.toFixed();
};

export const shouldShowStatistics = (
  isExpired: boolean,
  requiresLogin: boolean | undefined,
  isLoggedIn: boolean,
  votesCount: number = 0,
  answer?: string,
): boolean => {
  if (isExpired) {
    return true;
  }

  const hasAnswered = Boolean(answer);

  const hasVotes = votesCount > 0;

  if (requiresLogin) {
    return isLoggedIn && hasAnswered && hasVotes;
  }

  if (hasAnswered && hasVotes) {
    return true;
  }

  return false;
};

export const isExpired = (expirationDate: string | undefined): boolean =>
  expirationDate != null && isBefore(parseISO(expirationDate), startOfToday());

export const removeOldStatisticsFromLocalStorage = (): void => {
  if (!isLocalStorageSupported) return;

  const cutoffDate = subDays(new Date(), 40);

  Object.keys(window.localStorage).forEach((key) => {
    if (!key.startsWith('poll-vink-')) return;

    const storedPoll = getItemFromLocalStorage(key);
    if (!storedPoll) return;

    const poll: Statistics | null = JSON.parse(storedPoll);
    if (poll?.lastUpdated && isBefore(new Date(poll.lastUpdated), cutoffDate)) {
      removeItemFromLocalStorage(key);
    }
  });
};
